import { createI18n } from 'vue-i18n'

import en from './en'
import se from './se'

const messages = {
  en,
  se
}

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'se', // set locale
  fallbackLocale: 'se',
  messages, // set locale messages
})
